import { carouselItems } from '@/mocks/homeData';

export default function Carousel() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-7xl mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-xl md:text-3xl font-bold font-heading text-foreground-950">
            深度专题
          </h2>
          <p className="mt-3 text-sm text-foreground-600">
            五大深度专题，一网打尽最热门吃瓜话题
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {carouselItems.map((item, i) => (
            <a
              key={i}
              href="#carousel"
              className={`group block rounded-xl overflow-hidden bg-background-50 border border-background-200/60 hover:border-primary-200 transition-all duration-300 cursor-pointer ${
                i === 0 ? 'lg:col-span-2 lg:row-span-1' : ''
              }`}
            >
              <div className={`overflow-hidden bg-background-100 ${i === 0 ? 'aspect-[2/1]' : 'aspect-[4/3]'}`}>
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-4 md:p-5">
                <span className="inline-block px-2 py-0.5 text-xs font-medium bg-accent-100 text-accent-700 rounded-full mb-2 whitespace-nowrap">
                  {item.tag}
                </span>
                <h3 className="text-sm md:text-base font-semibold text-foreground-950 mb-2">
                  {item.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                  {item.desc}
                </p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}